import { SET_CAMPER_FORM, SET_CAMPER_FORM_FIELD } from './actionTypes'

export const setCamperForm = data => {
  return {
    type: SET_CAMPER_FORM,
    data
  }
}

export const setCamperFormField = (field, value) => {
  return {
    type: SET_CAMPER_FORM_FIELD,
    field,
    value
  }
}
